import { useRef, useEffect, useState } from "react";
import { ClipboardList, Stethoscope, Heart, Activity, ChevronLeft, ChevronRight } from "lucide-react";
import TapeMeasure from '../images/tape-measure.png';
import Adipometro from '../images/adipometro.png';
import Pulmao from '../images/lungs.png';
import Musculo from '../images/muscle.png';
import iconeEquilibrio from '../images/iconeEquilibrio.png';
import { etapasDoPerfil } from '../data/fluxoAvaliacao';
import '../css/Sub_menu.css';

function SubMenu({ activeTab, onTabChange, aluno }) {

    const perfil = aluno.profile;

    const scrollRef = useRef(null);
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(false);

    const checkScroll = () => {
        const el = scrollRef.current;
        if (!el) return;

        setCanScrollLeft(el.scrollLeft > 0);
        setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth);
    };

    useEffect(() => {
        const el = scrollRef.current;
        if (!el) return;

        checkScroll();
        el.addEventListener("scroll", checkScroll);
        window.addEventListener("resize", checkScroll);

        return () => {
            el.removeEventListener("scroll", checkScroll);
            window.removeEventListener("resize", checkScroll);
        };
    }, []);

    const handleScroll = (direction) => {
        const el = scrollRef.current;
        if (!el) return;

        const items = el.querySelectorAll(".sub-menu-list li");
        if (items.length === 0) return;

        const containerLeft = el.getBoundingClientRect().left;
        const visivel = el.clientWidth;
        const EPS = 1;
        let targetScrollLeft = el.scrollLeft;

        if (direction === "right") {
            // Avança até o primeiro item que está cortado/escondido à direita,
            // alinhando a borda DIREITA dele à borda direita visível (revela inteiro, sem cortar).
            for (let item of items) {
                const rect = item.getBoundingClientRect();
                const direitaRelativa = rect.right - containerLeft; // posição da direita do item no viewport
                if (direitaRelativa > visivel + EPS) {
                    targetScrollLeft += (direitaRelativa - visivel);
                    break;
                }
            }
        } else {
            // Volta até o primeiro item (da direita p/ esquerda) cortado/escondido à esquerda,
            // alinhando a borda ESQUERDA dele à borda esquerda visível (revela inteiro, sem cortar).
            for (let i = items.length - 1; i >= 0; i--) {
                const rect = items[i].getBoundingClientRect();
                const esquerdaRelativa = rect.left - containerLeft;
                if (esquerdaRelativa < -EPS) {
                    targetScrollLeft += esquerdaRelativa;
                    break;
                }
            }
        }

        // Garante limites válidos do scroll.
        const maxScroll = el.scrollWidth - el.clientWidth;
        targetScrollLeft = Math.max(0, Math.min(targetScrollLeft, maxScroll));

        el.scrollTo({
            left: targetScrollLeft,
            behavior: "smooth",
        });
    };

    // A ordem das abas vem de data/fluxoAvaliacao.js, a mesma usada pelos modais de próxima etapa.
    const ICONES_ETAPA = {
        Anamnese: <ClipboardList size={16} />,
        CapFuncionalQuest: <Activity size={16} />,
        TesteCapFunc: <Activity size={16} />,
        Katz: <ClipboardList size={16} />,
        Lawton: <ClipboardList size={16} />,
        EscalaBeg: <img className="sub-menu-icon" src={iconeEquilibrio} alt="" />,
        ParQ: <Stethoscope size={16} />,
        Coronariano: <Heart size={16} />,
        Antropometria: <img className="sub-menu-icon" src={TapeMeasure} alt="" />,
        AntropometriaIdosos: <img className="sub-menu-icon" src={TapeMeasure} alt="" />,
        "Composicao Corporal": <img className="sub-menu-icon" src={Adipometro} alt="" />,
        Vo2: <img className="sub-menu-icon" src={Pulmao} alt="" />,
        PrescricaoTreinoAerobico: <Activity size={16} />,
        AvaliacaoNeuromuscular: <img className="sub-menu-icon" src={Musculo} alt="" />,
        PrescricaoTreinoForca: <Activity size={16} />,
    };

    const menuItems = etapasDoPerfil(perfil).map((etapa) => ({
        key: etapa.chave,
        label: etapa.nome,
        icon: ICONES_ETAPA[etapa.chave],
    }));

    return (
        <div className="sub-menu-main">
            <div className="sub-menu-container">
                {/* Seta esquerda */}
                <button
                    type="button"
                    className={`sub-menu-arrow left ${!canScrollLeft ? "disabled" : ""}`}
                    onClick={() => handleScroll("left")}
                    disabled={!canScrollLeft}
                >
                    <ChevronLeft size={18} />
                </button>

                {/* Área rolável */}
                <div className="sub-menu-content">
                    <div className="sub-menu-itens" ref={scrollRef}>
                        <ul className="sub-menu-list">
                            {menuItems.map((item) => (
                                <li
                                    key={item.key}
                                    className={activeTab === item.key ? "active-item" : ""}
                                    onClick={() => onTabChange(item.key)}
                                >
                                    {item.icon} {item.label}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                {/* Seta direita */}
                <button
                    type="button"
                    className={`sub-menu-arrow right ${!canScrollRight ? "disabled" : ""}`}
                    onClick={() => handleScroll("right")}
                    disabled={!canScrollRight}
                >
                    <ChevronRight size={18} />
                </button>
            </div>
        </div>
    );
}

export default SubMenu;
